import { ComponentProps } from 'react';
import { DataTable } from '../../../design-system/data-table/data-table';
import { AccountView } from '../../../types/entity-types';
import { accountTableColumnsDefinition } from './accounts-table-column-definitions';

type DataTableProps = ComponentProps<typeof DataTable>;

type AccountsTableProps = Omit<DataTableProps, 'data' | 'columns'> & {
  accounts: AccountView[];
  showOptionsButton?: boolean;
  onDisconnectAccount?: (accountId: string) => Promise<void>;
  onReconnectAccount?: (account: AccountView) => Promise<void>;
};

export const AccountsTable = ({
  accounts,
  showOptionsButton,
  onDisconnectAccount,
  onReconnectAccount,
  ...props
}: AccountsTableProps) => {
  return (
    <DataTable<AccountView>
      columns={accountTableColumnsDefinition}
      data={accounts}
      showPagination={false}
      className="pt-0"
      meta={{
        rowHeight: 63,
        onDisconnectAccount,
        onReconnectAccount,
        showAccountOptions: showOptionsButton,
      }}
      {...props}
    />
  );
};
